/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
  // Add custom code below this line

  // Select the target node (the element to observe)
  const desktopCartCounter = document.getElementById('desktop_cart_counter');
  const mobCartCounter = document.getElementById('mob_cart_counter');

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver((mutationsList) => {
      for (let mutation of mutationsList) {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
              // Update mob_cart_counter text to match desktop_cart_counter
              mobCartCounter.textContent = desktopCartCounter.textContent;
          }
      }
  });

  // Configuration of the observer:
  const config = { childList: true, characterData: true, subtree: true };

  // Start observing the target node for configured mutations
  observer.observe(desktopCartCounter, config);

  // Debugging: Log changes to observe if the mutation is being detected
  desktopCartCounter.addEventListener('DOMSubtreeModified', () => {
      console.log('desktop_cart_counter modified:', desktopCartCounter.textContent);
  });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.


document.addEventListener("DOMContentLoaded", function() {
  const tabLinks = document.querySelectorAll(".col-tab-link");
  const tabContents = document.querySelectorAll(".tab-collection");

  tabLinks.forEach(function(link) {
    link.addEventListener("click", function(e) {
      e.preventDefault();

      tabLinks.forEach(function(link) {
        link.classList.add("as-col-nav");
        link.classList.remove("as-underline");
        link.classList.add("as-text-[#9F9F9F]");
        link.classList.remove("as-text-[#000]");
      });

      this.classList.remove("as-col-nav");
      this.classList.add("as-underline");
      this.classList.remove("as-text-[#9F9F9F]");
      this.classList.add("as-text-[#000]");

      const targetId = this.getAttribute("data-target");
      if (!targetId) return; // If no data-target attribute, exit

      tabContents.forEach(function(tabContent) {
        tabContent.classList.add("as-hidden");
      });

      const targetTab = document.getElementById(targetId);
      if (targetTab) {
        targetTab.classList.remove("as-hidden");
      }
    });
  });
});

document.addEventListener('click', function(event) {
  // Check if the clicked element matches '.select-popout__option'
  if (event.target.closest('.select-popout__option')) {
      // Find the span[data-qty-text] within the clicked element
      const qtyTextElement = event.target.closest('.select-popout__option').querySelector('span[data-qty-text]');
      const qtyText = qtyTextElement ? qtyTextElement.textContent : '';

      // Set the text of the '#qty-text' element
      const targetElement = document.querySelector('#qty-text');
      if (targetElement) {
          targetElement.textContent = qtyText;
      }
  }
});


/* =========================================================================
   Flavour selector fix (merged CGB PDP)  — v4
   -------------------------------------------------------------------------
   Admin tags such as "[Pre-Order] " were added to a Flavour option value
   (e.g. "[Pre-Order] Strawberry Smoothie"). Three PDP systems key off the
   flavour string:
     * subscription cards  -> rendered with the REAL value  {{ v.option2 }}
     * flavour selector    -> was hardcoded to the base name
     * left image gallery  -> matches media by the base flavour name

   data-flavor MATCHING is normalised to the base name (tag stripped) on both
   the buttons and the cards, so subscriptions + gallery both work. The REAL
   variant is untouched, so cart/checkout/orders still show "[Pre-Order]".
   The original full value is preserved in data-flavor-full so this routine is
   idempotent (safe to run more than once).

   The visible .sl-name label is cosmetic (nothing keys off it), so it shows
   the FULL, dynamic variant value pulled from the product
   (e.g. "[Pre-Order] Strawberry Smoothie") — except Sugar-Free, which keeps
   its custom "Zero" label. Safe no-op on any page without the selector.
   ========================================================================= */
(function () {
  function canon(s) {
    s = (s || '').trim();
    s = s.replace(/^\s*\[[^\]]*\]\s*/, ''); // drop a leading "[...]" tag
    return s.trim();
  }
  function isZero(s) {
    s = (s || '').toLowerCase();
    return s.indexOf('sugar') > -1 || s.indexOf('zero') > -1;
  }

  function fixFlavourSelector() {
    try {
      var wrap = document.querySelector('.sl-wrap');
      if (!wrap) return;

      // Build base-name -> full-variant-value map from the subscription cards.
      // Preserve each card's ORIGINAL full value in data-flavor-full so repeat
      // runs don't lose it after data-flavor has been normalised.
      var fullByBase = {};
      document.querySelectorAll('.lw-card[data-flavor], .lw-onetime [data-flavor]').forEach(function (el) {
        if (!el.hasAttribute('data-flavor-full')) {
          el.setAttribute('data-flavor-full', el.getAttribute('data-flavor'));
        }
        var full = el.getAttribute('data-flavor-full');
        var c = canon(full);
        if (c && !(c in fullByBase)) fullByBase[c] = full;
        if (c && el.getAttribute('data-flavor') !== c) el.setAttribute('data-flavor', c);
      });

      // Normalise selector buttons for matching (untagged names stay the same,
      // so the gallery keeps working), and label from the real variant value.
      wrap.querySelectorAll('.sl-option').forEach(function (btn) {
        if (!btn.hasAttribute('data-flavor-full')) {
          btn.setAttribute('data-flavor-full', btn.getAttribute('data-flavor') || '');
        }
        var c = canon(btn.getAttribute('data-flavor-full'));
        if (c && btn.getAttribute('data-flavor') !== c) btn.setAttribute('data-flavor', c);

        var nameEl = btn.querySelector('.sl-name');
        if (nameEl) {
          var label = isZero(c) ? 'Zero' : (fullByBase[c] || canon(btn.getAttribute('data-flavor-full')) || c);
          nameEl.textContent = label;
          var img = btn.querySelector('img');
          if (img) img.setAttribute('alt', label);
        }
      });
    } catch (e) {
      if (window.console) console.warn('flavour selector fix skipped:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixFlavourSelector);
  } else {
    fixFlavourSelector();
  }
  setTimeout(fixFlavourSelector, 1500);
})();


/* =========================================================================
   Flavour switcher — same-page, cross-product add-to-cart — v6
   -------------------------------------------------------------------------
   Each flavour is its own product listing (like gruns.co), but the switch
   happens ON THE SAME PAGE — no redirect. Because all four products share
   the SAME selling plan IDs ("Subscribe and Save 16.10%" + "90-Day Supply"),
   the only thing that must change per flavour is the VARIANT ID.

   How it works:
     1. On load, every subscription card / one-time option gets its
        data-variant-id REMAPPED to the equivalent variant (same box size)
        on the flavour's OWN product. Selling plan IDs are left untouched.
     2. Clicking a flavour in .sl-wrap shows only that flavour's cards and
        selects the first one — the hidden form input now holds the sibling
        product's variant, so add-to-cart shows the correct product title
        (e.g. "Collagen Glow Créme Yogurt", not "… Zero / Flavour: Créme
        Yogurt").
     3. The URL is quietly swapped to the flavour's own PDP with
        history.replaceState (no reload) so refresh/share lands on the
        right product. Skipped inside the theme editor.

   NOTE: if variants are ever added/removed on these four products, update
   the NATIVE_VARIANTS and BOX_90_VARIANTS maps below.
   Runs only on the four CGB merged PDPs; safe no-op everywhere else.
   ========================================================================= */
(function () {
  var HANDLE_TO_KEY = {
    'collagen-glow-berries': 'original',
    'collagen-glow-berries-zero': 'zero',
    'collagen-glow-strawberry-smoothie': 'strawberry',
    'collagen-glow-creme-yogurt': 'yogurt'
  };
  var KEY_TO_URL = {
    'original': '/products/collagen-glow-berries',
    'zero': '/products/collagen-glow-berries-zero',
    'strawberry': '/products/collagen-glow-strawberry-smoothie',
    'yogurt': '/products/collagen-glow-creme-yogurt'
  };

  // Native-flavour variant of each product, by box size (30 / 90 sachets)
  var NATIVE_VARIANTS = {
    'original':   { '30': '49967108784357', '90': '49967108849893' },
    'zero':       { '30': '49464853692645', '90': '49464853725413' },
    'strawberry': { '30': '50946388492517', '90': '50946388623589' },
    'yogurt':     { '30': '50946803794149', '90': '50946803925221' }
  };

  // Every 90-sachet variant id across all four products.
  // Anything not in this set is treated as a 30-sachet variant.
  var BOX_90_VARIANTS = {};
  ['49464853725413','50948446453989','50948446486757','50948446519525',
   '50946388623589','50946388656357','50946388689125','50946388721893',
   '50946803925221','50946803957989','50946803990757','50946804023525',
   '49967108849893','49967210528997','49967210561765','49967108882661'
  ].forEach(function (id) { BOX_90_VARIANTS[id] = true; });

  function canon(s) {
    s = (s || '').trim();
    s = s.replace(/^\s*\[[^\]]*\]\s*/, '');
    return s.trim();
  }
  function flavourKey(s) {
    s = canon(s).toLowerCase();
    if (!s) return null;
    if (s.indexOf('sugar') > -1 || s.indexOf('zero') > -1) return 'zero';
    if (s.indexOf('strawberry') > -1) return 'strawberry';
    if (s.indexOf('yogurt') > -1) return 'yogurt';
    if (s.indexOf('original') > -1 || s.indexOf('berr') > -1) return 'original';
    return null;
  }
  function elKey(el) {
    return flavourKey(el.getAttribute('data-flavor-full') || el.getAttribute('data-flavor'));
  }
  function currentHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  function buyables() {
    return document.querySelectorAll('.lw-card[data-flavor], .lw-onetime [data-flavor]');
  }

  // Point every option at the flavour's OWN product variant (same box size)
  function remapVariantIds() {
    buyables().forEach(function (el) {
      var key = elKey(el);
      if (!key || !NATIVE_VARIANTS[key]) return;
      var id = el.getAttribute('data-variant-id');
      if (!id) return;
      var box = BOX_90_VARIANTS[id] ? '90' : '30';
      var target = NATIVE_VARIANTS[key][box];
      if (target && id !== target) el.setAttribute('data-variant-id', target);
    });
  }

  function setFlavour(key, updateUrl) {
    // Selector highlight
    document.querySelectorAll('.sl-wrap .sl-option').forEach(function (btn) {
      btn.classList.toggle('sl-option--active', elKey(btn) === key);
    });

    // Show only this flavour's purchase options
    document.querySelectorAll('.lw-card[data-flavor]').forEach(function (card) {
      card.style.display = (elKey(card) === key) ? '' : 'none';
    });
    document.querySelectorAll('.lw-onetime [data-flavor]').forEach(function (el) {
      el.style.display = (elKey(el) === key) ? '' : 'none';
    });

    // Swap the URL to the flavour's own PDP (no reload). Skip in theme editor.
    if (updateUrl && KEY_TO_URL[key] && !(window.Shopify && window.Shopify.designMode)) {
      try {
        var params = new URLSearchParams(window.location.search);
        params.delete('variant');
        var q = params.toString();
        window.history.replaceState({}, '', KEY_TO_URL[key] + (q ? '?' + q : ''));
      } catch (e) { /* non-fatal */ }
    }

    // Re-select the first visible card so the form's hidden inputs update
    var active = document.querySelector('.lw-card.active');
    if (!active || active.style.display === 'none') {
      var cards = document.querySelectorAll('.lw-card');
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].style.display !== 'none') { cards[i].click(); break; }
      }
    }
  }

  function initFlavourSwitcher() {
    try {
      var wrap = document.querySelector('.sl-wrap');
      if (!wrap) return;
      var nativeKey = HANDLE_TO_KEY[currentHandle()];
      // Fall back: if URL isn't one of the four PDPs (e.g. after replaceState
      // in an odd context), derive from the first subscription card.
      if (!nativeKey) {
        var firstCard = document.querySelector('.lw-card[data-flavor]');
        nativeKey = firstCard ? elKey(firstCard) : null;
      }
      if (!nativeKey) return;

      remapVariantIds();

      // Bind flavour buttons once
      wrap.querySelectorAll('.sl-option').forEach(function (btn) {
        if (btn.dataset.slSwitch) return;
        btn.dataset.slSwitch = '1';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var key = elKey(btn);
          if (key) setFlavour(key, true);
        });
      });

      // Initial state: only apply if some cross-flavour card is still visible
      // or nothing is selected yet (keeps re-runs from fighting the user).
      var selectedBtn = wrap.querySelector('.sl-option--active');
      var currentKey = selectedBtn ? elKey(selectedBtn) : null;
      var needInit = false;
      var visibleMismatch = document.querySelectorAll('.lw-card[data-flavor]');
      for (var i = 0; i < visibleMismatch.length; i++) {
        var c = visibleMismatch[i];
        if (c.style.display !== 'none' && elKey(c) !== (currentKey || nativeKey)) { needInit = true; break; }
      }
      var active = document.querySelector('.lw-card.active');
      if (!active || active.style.display === 'none') needInit = true;
      if (needInit) setFlavour(currentKey || nativeKey, false);
    } catch (e) {
      if (window.console) console.warn('flavour switcher skipped:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlavourSwitcher);
  } else {
    initFlavourSwitcher();
  }
  setTimeout(initFlavourSwitcher, 300);
  setTimeout(initFlavourSwitcher, 1600);
})();


/* =========================================================================
   Flavour chips dynamic order + native default — v7  (ab060 template ONLY)
   -------------------------------------------------------------------------
   1. Reorders the .sl-option flavour chips to match the PRODUCT'S OWN
      variant order (the Flavour option values as they appear across
      product.variants), instead of the hardcoded template order. On each
      merged PDP the product's native flavour is listed first in its
      variants, so its chip leads.
   2. Defaults the FIRST chip (the native flavour) as the selected one —
      the hardcoded HTML marks "Original" active, so without this the page
      always opened on Original regardless of which product was viewed.
      The default is applied via a real click so v6 (and the merged
      gallery, when enabled) run their full flavour-swap logic.

   Scope: runs only when the rendered template is ab060-3months-merged-cgb
   (detected via window.__tplSuffix set in loop-widget-custom.css.liquid, or
   a ?view=ab060-3months-merged-cgb URL). ab049 (A/B control) is untouched.

   Variant order comes from the ProductJson script rendered by the theme;
   flavour values map to chips with the same canon/keyword matching used by
   v4/v6, so "[Pre-Order]"-tagged values still match. Safe no-op elsewhere.
   ========================================================================= */
(function () {
  function isAb060() {
    if (window.__tplSuffix === 'ab060-3months-merged-cgb') return true;
    return /[?&]view=ab060-3months-merged-cgb(&|$)/.test(window.location.search);
  }
  function canon(s) {
    s = (s || '').trim();
    s = s.replace(/^\s*\[[^\]]*\]\s*/, '');
    return s.trim();
  }
  function flavourKey(s) {
    s = canon(s).toLowerCase();
    if (!s) return null;
    if (s.indexOf('sugar') > -1 || s.indexOf('zero') > -1) return 'zero';
    if (s.indexOf('strawberry') > -1) return 'strawberry';
    if (s.indexOf('yogurt') > -1) return 'yogurt';
    if (s.indexOf('original') > -1 || s.indexOf('berr') > -1) return 'original';
    return null;
  }
  function chipKey(c) {
    return flavourKey(c.getAttribute('data-flavor-full') || c.getAttribute('data-flavor'));
  }

  function run() {
    try {
      if (!isAb060()) return;
      var options = document.querySelector('.sl-wrap .sl-options');
      if (!options) return;

      /* ---- 1. Reorder chips to the product's variant order (once) ---- */
      if (!options.dataset.slReordered) {
        var jsonEl = document.querySelector('script[data-product-json]');
        if (!jsonEl) return;
        var prod = {};
        try { prod = JSON.parse(jsonEl.textContent) || {}; } catch (e) { return; }
        var variants = prod.variants || [];
        if (!variants.length) return;

        // Which option position holds the Flavour? (default: option2)
        var fIdx = 1;
        if (prod.options && prod.options.length) {
          for (var i = 0; i < prod.options.length; i++) {
            var name = typeof prod.options[i] === 'string'
              ? prod.options[i]
              : ((prod.options[i] && prod.options[i].name) || '');
            if (/flavou?r/i.test(name)) { fIdx = i; break; }
          }
        }

        // Distinct flavour keys in the product's own variant order
        var order = [], seen = {};
        variants.forEach(function (v) {
          var val = v['option' + (fIdx + 1)];
          if (val == null && v.options) val = v.options[fIdx];
          var k = flavourKey(val);
          if (k && !seen[k]) { seen[k] = true; order.push(k); }
        });
        if (order.length < 2) return;

        // Map chips by flavour key (original DOM order preserved for leftovers)
        var chips = Array.prototype.slice.call(options.querySelectorAll('.sl-option'));
        if (chips.length < 2) return;
        var byKey = {};
        chips.forEach(function (c) {
          var k = chipKey(c);
          if (k && !byKey[k]) byKey[k] = c;
        });

        // Re-append: variant-ordered flavours first, then any unmatched chips
        order.forEach(function (k) { if (byKey[k]) options.appendChild(byKey[k]); });
        chips.forEach(function (c) {
          var k = chipKey(c);
          if (!k || order.indexOf(k) === -1) options.appendChild(c);
        });

        options.dataset.slReordered = '1';
      }

      /* ---- 2. Default-select the FIRST chip (native flavour), once ---- */
      if (!options.dataset.slDefaulted) {
        var first = options.querySelector('.sl-option');
        if (!first) return;
        var activeNow = options.querySelector('.sl-option--active');
        options.dataset.slDefaulted = '1';
        if (activeNow !== first || chipKey(activeNow) !== chipKey(first)) {
          // Real click so v6 (and merged-gallery, when enabled) do the full swap:
          // highlight, buy-box filter, gallery group, title, FAQ, URL.
          setTimeout(function () { first.click(); }, 0);
        }
      }
    } catch (e) {
      if (window.console) console.warn('sl-option reorder skipped:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 300);
  setTimeout(run, 1600);
})();
